
export const createState = () => ({
  errorModal: null
})

export const actions = {
  setErrorModal({ title, message,content=null,comingFrom,setState }) {
    gtag('config', 'G-X7BSWEKXG0', {
      'custom_map': {
        'dimension1': 'ss_runtime_error',			
      }});
    gtag('event', 'Errors', {'ss_runtime_error': 'Run Time Error'});
    setState({
      errorModal: { title, message, content,comingFrom, setState }
    })
  },
  clearErrorModal({ setState }) {
    setState({
      errorModal: null
    })
  },  
}
